export default {"src":"/_next/static/media/warning-icon-2.dc46f0e9.svg","height":24,"width":24};